import { Button, Grid, Typography, useMediaQuery, Link, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { RightContainer } from "../../components/RightContainer";
import WhiteInosio from "../../icons/whiteinosio.svg"
interface Props {}

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    height: "100%",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    width: "42%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  mainTitle: {
    fontFamily: "BMW Helvetica 75 !important",
    fontStyle: "normal",
    fontSize: "24px !important",
    lineHeight: "30px !important",
    color: "#14142B",
    margin: "0 16px !important",
  },
  text: {
    fontFamily: "Work Sans",
    fontSize: "18px !important",
    margin: "17px 0 !important",
  },
  roleBtn: {
    background: "#39A2DB !important",
    borderRadius: "24px !important",
    color: "#fff !important",
    marginBottom: "20px !important",
    width: "100% !important",
    height: "49px",
  },
  Btn: {
    background: "#fff !important",
    borderRadius: "24px !important",
    color: "#39A2DB !important",
    marginBottom: "20px !important",
    border: "1px solid #39A2DB !important",
    width: "100% !important",
    height: "49px",
  },
  BtnContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
  BtnContainerIpad: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  BtnContainerMobile: {
    display: "flex",
    justifyContent: "space-between",
    height: "40vh",
    width: "80vw",
  },
  helpIcon: {
    fontSize: "13px !important",
    color: "#C4C4C4",
    cursor: "pointer",
  },
}));

export const SignUp = (props: Props) => {
  const matchesMobile = useMediaQuery("(max-width:600px)");
  const matchesIpad = useMediaQuery("(max-width:850px)");
  const matches300 = useMediaQuery("(max-width:300px)");
  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");
  const classes = useStyles();

  return (
    <div className={classes.rootContainer}>
      <Grid sx={{ flexDirection: "column" }} className={classes.leftContainer}>
        <Box pb={6} sx={{ display: "flex", alignItems: "center" }}>
          <img src={WhiteInosio} style={{ width: "150px", height: "150px" }}  alt="logo" />
        </Box>
        <Box sx={{ width: "200px" }}>
          <Typography className={classes.text}>
            Tell us about yourself
          </Typography>
        </Box>

        <Box
          className={`${
            matchesIpad ? classes.BtnContainerIpad : classes.BtnContainer
          }
              
              ${
                matchesMobile
                  ? classes.BtnContainerMobile
                  : classes.BtnContainer
              }
              
              `}
        >
          <Grid>
            {" "}
            <Button className={classes.roleBtn} href="/residentpage">
              Resident
            </Button>
            <Button className={classes.roleBtn} href="/owner">
              Owner
            </Button>
            <Button className={classes.roleBtn} href="/onboarding/basiccompanyinfo">
              Property manager
            </Button>
          </Grid>
          <Grid>
            {" "}
            <Button className={classes.Btn} href="/login">
              I have an account
            </Button>
          </Grid>
          <Box sx={{ width: "100%", margin: "2% 0 !important" }}>
            <Divider />
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                flexDirection: matches300 ? "column" : "row",
              }}
            >
              <Link
                sx={{
                  font: "14px Work Sans",
                  lineHeight: "30px",
                  color: "#39A2DB",
                  textDecoration: "none !important",
                  maxHeight: "30px !important",
                  cursor: "pointer",
                  zIndex: 30,
                  width: "fit-content",
                  textAlign: "center",
                  marginTop: "4%",
                }}
                href="/code"
              >
                I have a special code
              </Link>
            </Grid>
          </Box>
        </Box>

      </Grid>

      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer />
        </Grid>
      ) : (
        <></>
      )}

    </div>
  );
};
